import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../components/useListadoRecordado';
import axios from '../../axiosConfig';
import Table from 'react-bootstrap/Table';
import { Modal } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { useLoading } from '../../components/LoadingContext'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationTable from '../../components/PaginationTable'; 
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { FaSync,FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import { FaLocationDot } from "react-icons/fa6";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28'];




const ShowProcedencias = () => {
    const [procedencias, setProcedencias] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [filteredReportes, setFilteredReportes] = useState([]);
    const [searchName, setsearchName] = useState('');
    const [error, setError] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const userRole = localStorage.getItem('role'); // Obtener el rol del usuario desde el localStorage
    const itemsPerPage = 4; // Número de elementos por página
    const [avgMontoCancelado, setAvgMontoCancelado] = useState(0);
    const [latestTasa, setLatestTasa] = useState({ tasa: 0, created_at: '' });
    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const [range, setRange] = useState(30); // Estado para seleccionar el rango de días
    const [statistics, setStatistics] = useState({});
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
    const [showModalInfo, setShowModalInfo] = useState(false);


    // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado('procedencias', {
        descripcion: '', 
        cod:'',   
        status:true,
        activo:''
    });
    const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : "");
    
    const handleShowModal = (id) => {
        setSelectedId(id);  // Almacena el ID del participante que se va a eliminar
        setShowModal(true); // Muestra el modal
    };
    
    const handleCloseModal = () => {
        setShowModal(false); // Cierra el modal
    };   

    useEffect(() => {
        setLoading(true);
        getAllProcedencias(currentPage).finally(() => {
            setLoading(false);
        });
    }, []);


    const getAllProcedencias = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/procedencia-estadisticas`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina },
            });
            
            const estadisticas = response.data.estadisticas || {};
            
            setProcedencias(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setProcedencias([]);
            setStatistics({});
        }
    };
    
    const deleteProcedencia = async () => {
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`/procedencia/${selectedId}`,{
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                getAllProcedencias();
                setShowModal(false); // Cierra el modal tras la eliminación exitosa
                toast.success('Procedencia eliminado con éxito');
            } catch (error) {
                setError('Error deleting data');
                console.error('Error deleting data:', error);
                toast.error('Error al eliminar el Procedencia');
            }
        
    };
 
  
    const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {
            await (getAllProcedencias()); // Espera a que getAllDatos haga la solicitud y actualice los datos
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };
 
    const handlePageChange = (page) => {
        setCurrentPage(page);
        getAllProcedencias(page); // Llama a `getAllDatos` con el nuevo número de página

    };

    const printInfo = async (filters) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Token no encontrado.');
                return;
            }

            const response = await axios.get(`/procedencia-print`, {
                headers: { Authorization: `Bearer ${token}` },
                params: filters,
            });

            const jsonData = response.data.datos;
            const estadisticasData = response.data.estadisticas;

            if (!jsonData || jsonData.length === 0) {
                alert('No hay datos para exportar.');
                return;
            }

            const worksheet1 = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet1, 'Datos');

            const estadisticasArray = Object.entries(estadisticasData).map(([key, value]) => ({
                Estadistica: key,
                Valor: value,
            }));
            const worksheet2 = XLSX.utils.json_to_sheet(estadisticasArray);
            XLSX.utils.book_append_sheet(workbook, worksheet2, 'Estadisticas');

            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, 'procedencias.xlsx');
        } catch (error) {
            console.error('Error al generar el archivo Excel', error);
            alert('Hubo un error al generar el archivo Excel');
        }
    };

    const handlePrint = async () => {
        setShowModalInfo(false);
        await printInfo(filters);
    };

    const totalProcedencias = statistics.totalProcedencias || 0;


    const columns = ["id", "Nombre","COD","Fecha de Creación", "Creado por", "Acciones"];

    const renderItem = (procedencias) => (
        <tr key={procedencias.id}>
        <td >{procedencias.id}</td>
        <td >{procedencias.descripcion}</td>
        <td >{procedencias.cod}</td>
        <td >{moment(procedencias.fecha).format('YYYY-MM-DD')}</td>
        {/* Los registros anteriores a la columna user_id pueden no tenerlo. */}
        <td >{procedencias.creador?.username || '—'}</td>
       
        <td >
            <div className="d-flex justify-content-around">

                {['admin', 'coordinador', 'creador-cursos', 'asist-centro'].includes(userRole) ? (
                <Button
                    variant="btn btn-warning"
                    onClick={() => navigate(`/procedencias/edit/${procedencias.id}`)}
                    className="me-2"
                    title='Editar'
                >
                    <i className="bi bi-pencil-fill"></i>
                </Button>
               ) : null}
                {userRole === 'admin' && (
                

                <Button
                variant="btn btn-danger"
                onClick={() => handleShowModal(procedencias.id)}
                className="me-2"
                title='Eliminar'
                >
                <i className="bi bi-trash3-fill"></i>
                </Button>
                )}
            </div>
        </td>
        </tr>
    );

    return (
        <div className="container-fluid mt-2" style={{ fontSize: '0.85rem' }}>
            <div className="col-lg-11 mx-auto d-flex justify-content-center"> 
                <div className="stat-box d-flex justify-content-center align-items-center" style={{ maxWidth: '100%' }}>
                    {/* Total de Procedencias */}
                    <div className="stat-card text-center" style={{ padding: '5px', width: '100%' }}>
                        <div className="stat-icon"><FaLocationDot /></div>
                        <div className="stat-number" style={{ color: '#58c765', fontSize: '1.2rem' }}>{totalProcedencias}</div>
                        <div className="stat-label">Total de Procedencias</div>
                    </div>
                </div>
            </div>




            <div className="row" style={{ marginTop: '10px' }}>
                {/* Columna para la tabla */}
                <div className="col-lg-11 mx-auto"> {/* Agregamos 'mx-auto' para centrar */}
                    <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}> 
                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '0px' }}>
                        <h2>Lista de Procedencias</h2>
                        <div className="d-flex align-items-center">
                             <Form.Select
                                name="activo"
                                value={filters.activo}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.activo)}
                                style={{ width: 'auto' }}
                                >
                                <option value="">Status</option>
                                <option value="true">Procedencias Activas</option>
                                <option value="false">Procedencias Inactivas</option>
                            </Form.Select>  
                            <Form.Control
                                name='descripcion'
                                type="text"
                                placeholder="Buscar por Nombre"
                                value={filters.descripcion}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.descripcion)}
                            />
                            <Form.Control
                                name='cod'
                                type="text"
                                placeholder="Buscar por Cod"
                                value={filters.cod}
                                onChange={handleFilterChange}
                                className={activeFilterClass(filters.cod)}
                            />
                            <Button
                                variant="info me-2"
                                onClick={loadData}
                                disabled={loadingData} // Deshabilita el botón si está cargando
                                style={{ padding: '5px 10px', width: '90px' }} // Ajusta padding y ancho
                                title='Recargar datos'

                                >
                                {/* Icono de recarga */}
                                {loadingData ? (
                                    <FaSync className="spin" /> // Ícono girando si está cargando
                                ) : (
                                    <FaSync />
                                )}
                            </Button>
                            <Button
                                    variant="info me-2"
                                    onClick={getAllProcedencias}
                                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                    title='Buscar'
                                >
                                    <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                </Button>
                            <Button
                                variant="success"
                                onClick={() => setShowModalInfo(true)}
                                className="me-2"
                                title="Exportar a Excel"
                                style={{ padding: '5px 12px' }}
                            >
                                <i className="bi bi-file-earmark-excel-fill"></i>
                            </Button>
                            {['admin', 'coordinador', 'creador-cursos', 'asist-centro'].includes(userRole) ? (

                            <Button variant="btn custom" onClick={() => navigate('/procedencias/create')} className="btn-custom" title='Crear Procedencia'>
                            <i className="bi bi-geo-fill me-2  "></i> Nuevo
                            </Button>
                            ):null}
                        </div>
                    </div>
                    {/* Tabla paginada */}
                    
                        <PaginationTable
                            data={procedencias}
                            itemsPerPage={itemsPerPage}
                            columns={columns}
                            renderItem={renderItem}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            totalPages={totalPages}  
                        />


                    {/* Modal de confirmación de exportación */}
                    <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <i className="bi bi-file-earmark-excel-fill text-success me-2"></i>
                                Exportar a Excel
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center py-4">
                            <i className="bi bi-cloud-download" style={{ fontSize: '3.5rem', color: '#3D80C8' }}></i>
                            <p className="mt-3 mb-1 fw-semibold">¿Deseas descargar la información actual?</p>
                            <small className="text-muted">El archivo respetará los filtros aplicados.</small>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex justify-content-end gap-2 w-100">
                                <Button variant="secondary" onClick={() => setShowModalInfo(false)}>
                                    Cancelar
                                </Button>
                                <Button variant="success" onClick={handlePrint}>
                                    <i className="bi bi-download me-1"></i> Descargar Excel
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal  de eliminación */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar eliminación</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>¿Estás seguro de que deseas eliminar esta Procedencia?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancelar
                    </Button>
                    <Button variant="danger" onClick={deleteProcedencia}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </div>
        
        </div>
        </div>
        </div>
    );
};

export default ShowProcedencias;
